import React, { useState } from "react";
import { RxEyeOpen } from "react-icons/rx";
import { VscEyeClosed } from "react-icons/vsc";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  forgotPassword,
  login,
  verifyOtp,
} from "../../redux/services/authSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import Otpverify from "../../models/Otpverify";
import { useNavigate } from "react-router-dom";
import ForgotPassword from "../../models/ForgotPassword";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [getLoading, setGetLoading] = useState(false);
  const [getVerifyLoading, setGetVerifyLoading] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [email, setEmail] = useState("");
  const [emailData, setEmailData] = useState("");
  const [otpValue, setOtpValue] = useState({
    otp: "",
    userType: "classes",
  });
  const initialValues = {
    uniqueId: "",
    password: "",
    userType: "classes",
  };
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
  const validationSchema = Yup.object({
    uniqueId: Yup.string()
      .email("Please Enter Valid Email")
      .required("Please Enter Your Email"),
    password: Yup.string()
      .min(8, "Enter at least 8 characters")
      .matches(
        passwordRegex,
        "Must include uppercase, lowercase, number and symbol."
      )
      .required("Please Enter Your Password"),
  });
  const onSubmit = async (values) => {
    setGetLoading(true);
    try {
      let response = await dispatch(login(values));
      if (response?.payload?.status === 200) {
        setConfirm(true);
        setEmailData(response?.payload?.data?.email);
        resetForm();
      }
    } catch (err) {
    } finally {
      setGetLoading(false);
    }
  };

  const {
    handleChange,
    errors,
    touched,
    handleSubmit,
    resetForm,
    handleBlur,
    values,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit,
  });

  const handleChangeOTP = (e) => {
    const value = e.target.value;
    if (/[^0-9]/.test(value)) {
      return;
    }
    setOtpValue({
      ...otpValue,
      otp: value,
    });
  };
  const verifyOtpHandler = async () => {
    setGetVerifyLoading(true);
    try {
      if (otpValue.otp === "" && !otpValue.userType) {
        toast("Fill up empty space", {
          autoClose: 2000,
          pauseOnHover: false,
        });
        return;
      }

      let response = await dispatch(verifyOtp(otpValue));
      if (response?.payload?.data?.isEmailVerified) {
        setConfirm(false);
        navigate(email ? `/reset-password?email=${email}` : "/");
        setEmail("");
      }
    } catch (error) {
    } finally {
      setGetVerifyLoading(false);
    }
  };

  const makeForgotPasswordRequest = async (email) => {
    let payload = { uniqueId: email, userType: "classes" };
    try {
      const response = await dispatch(forgotPassword(payload));
      return response;
    } catch (error) {
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    try {
      const response = await makeForgotPasswordRequest(email);
      setForgotLoading(false);
      if (response) {
        setForgotPasswordModal(false);
        setConfirm(true);
        alert("Check your email for the reset link!");
      }
    } catch (error) {
    } finally {
      setForgotLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setForgotLoading(true);
    try {
      const response = await makeForgotPasswordRequest(email || emailData);
      if (response) {
        alert("OTP sent again to your email!");
      }
    } catch (error) {
    } finally {
      setForgotLoading(false);
    }
  };
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-[#124699]">
      <div className="bg-white p-8 rounded-md shadow-md w-full max-w-lg mx-3">
        <h2 className="text-xl font-bold text-[#405189] text-center mb-1">
          Welcome Back!
        </h2>
        <p className="text-center text-gray-500 mb-4">Sign In</p>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="text"
              name="uniqueId"
              value={values.uniqueId}
              onBlur={handleBlur}
              onChange={handleChange}
              errors={errors}
              touched={touched}
              placeholder="Enter Your Email Address"
              autoComplete="off"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            {errors.uniqueId && touched.uniqueId && (
              <p className="mt-1 px-2 text-red-600 text-sm">
                {errors.uniqueId}
              </p>
            )}
          </div>
          <div className="mb-1">
            <label className="block text-sm font-medium mb-1">Password</label>
            <div className="relative">
              <input
                type={show ? "text" : "password"}
                placeholder="Enter password"
                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                name="password"
                onBlur={handleBlur}
                value={values.password}
                onChange={handleChange}
                errors={errors}
                touched={touched}
                autoComplete="off"
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-blue-600 rounded-e-md focus:outline-none"
              >
                {show ? (
                  <VscEyeClosed title="Show Password" color="#878a99" />
                ) : (
                  <RxEyeOpen title="Hide Password" color="#878a99" />
                )}
              </button>
            </div>
            {errors.password && touched.password && (
              <p className="mt-1 px-2 text-red-600 text-sm">
                {errors.password}
              </p>
            )}
          </div>
          <div
            className="flex items-start justify-end ms-2 cursor-pointer"
            onClick={() => setForgotPasswordModal(true)}
          >
            <div className="text-blue-800 text-md hover:underline">
              <p>Forgot password?</p>
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-[#F48224] mt-7 text-white py-2 rounded-md hover:bg-[#e0731a] transition flex justify-center"
          >
            {getLoading ? <div className="loader"></div> : "Sign In"}
          </button>
        </form>
      </div>
      <div className={`${confirm === true ? "block" : "hidden"}`}>
        <Otpverify
          confirm={confirm}
          onClose={() => setConfirm(false)}
          getVerifyLoading={getVerifyLoading}
          email={email || emailData}
          otpValue={otpValue.otp || ""}
          handleChangeOTP={handleChangeOTP}
          handleOtpverify={verifyOtpHandler}
          handleResendOTP={handleResendOTP}
        />
      </div>
      {forgotPasswordModal && (
        <ForgotPassword
          setForgotPasswordModal={setForgotPasswordModal}
          forgotPasswordModal={forgotPasswordModal}
          handleForgotPassword={handleForgotPassword}
          email={email}
          setEmail={setEmail}
          forgotLoading={forgotLoading}
        />
      )}
    </div>
  );
};

export default Login;
